<template>
  <div class="nomination-review">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <template v-if="nominationCategory === 'Employee of the Month'">
          <ContentHeader name="Review Employee of the Month Nomination"></ContentHeader>
        </template>
        <template v-else-if="nominationCategory === 'Team of the Month'"> 
          <ContentHeader name="Review Team of the Month Nomination"></ContentHeader>
        </template>
        <!--h4 class="text-black-50">You've been identified to review the nomination for <router-link to="">{{nominationCategory}}</router-link> by:</h4-->
        <div class="pt-2 mb-3" v-if="this.nomination.isteamaward[0] !== undefined && this.nomination.isteamaward[0] == 'true'">
          <h5>Nominated Team Members:</h5>
          <ul>
            <li v-for="teams in nomination.nominationteam[0]" v-bind:key="teams.member_slug">
              <h6>
                <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
                <a href="#">{{teams.member_name}}</a>
              </h6>
              <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> Employee Number:</span> {{ teams.member_employee_number }}</h6>
              <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{teams.member_company}}</h6>
            </li>
          </ul>
        </div>
        <div class="pt-2 mb-3" v-else>
          <h5>Nominee Details:</h5>
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="#">{{nomination.nominee_name[0]}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominee_company[0]}}</h6>
        </div>
        <hr>
        <div class="pt-2 mb-3">
          <h5> Nominator Details: </h5>
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="#">{{nomination._embedded.author[0].name}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nominatorCompany}}</h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> On:</span> {{ nominationDate }}</h6>
        </div>
        <hr>
        <!--h4 class="text-black-50">Nomination:</h4-->
        <div class="mb-3" v-html="nomination.content.rendered"></div>
        <!--router-link v-if="nomination.supporting_documentation.length !== 0" :to="'/supporting-documentation/' + nomination.supporting_documentation" target="_blank" class="btn btn-primary mb-3">View Image of Employee Nominated</router-link-->
        <template v-for="docIdArray in nomination.supporting_documentation">
          <template v-for="docId in docIdArray">
            <router-link :key="docId" :to="'/supporting-documentation/' + docId" target="_blank" class="btn btn-primary mb-3">View Image of Employee Nominated </router-link><br>
          </template>
        </template>
        <hr>
        <div>
          <h4 class="text-black-30">Selection Period:</h4>
          {{ nomination.selectionperiod[0] }}
        </div>
        <hr>
        <!--div v-if="hierarchicalMessage.length > 1">
          <h4 class="text-black-30">Review Comments:</h4>
          <div class="hierarchicalMessage" v-for="messages in hierarchicalMessage" v-bind:key="messages.id">
            <template v-if="messages.project_sponsor_name === 'Exco2'">
              <span v-if="messages.project_sponsor_comment !== '' || messages.project_sponsor_status === 'Approve'">
                <h6><span class="text-black-50">{{workflowStagesLabel[workflowStages.indexOf(messages.project_sponsor_name.toLowerCase())]}}:</span></h6>
                <span>{{messages.project_sponsor_comment}}</span>
                <hr v-if="hierarchicalMessage.length > 1">
              </span>
            </template>
          </div>
        </div-->
        <div v-if="!stageApprove && $route.params.hasOwnProperty('level')">
          <div v-if="showSubstationFields">
            <h4 class="text-black-50 mb-4">Please complete the fields below in order to further complete the nomination.</h4>
            <div class="alert alert-danger" v-if="validationErrMsg !== ''">{{validationErrMsg}}</div>
            <Field150Word
              label="Add comments:"
              label-secondary=""
              :is-required="true"
              v-on:added150WordContent="populateFieldInput($event)"
              :display-field="true"
              error-class="">
            </Field150Word>
            <div class="row py-1">
              <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                  <label for="terms" class="form-check-label">Accept the
                    <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                  </label>
                </div>
                <div v-if="termsNotAccepted" class="alert alert-danger">
                  Please accept the terms before Approving or Rejecting a nomination
                </div>
              </div>
            </div>
            <div class="row pt-2 mb-4">
              <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                <button type="button" class="btn btn-success btn-lg" v-on:click="acceptDecline('Approve')">
                  <i class="far fa-thumbs-up fa-fw"></i> Approve
                </button>
                <button type="button" class="btn btn-danger btn-lg" v-on:click="acceptDecline('Reject')">
                  <i class="far fa-thumbs-down fa-fw"></i> Reject
                </button>
              </div>
            </div>
          </div>
          <div v-if="!showSubstationFields" role="alert" class="alert alert-success">{{acceptDeclineMsg}}</div>
        </div>
        <div v-if="stageApprove && !displayHM">
          <div role="alert" class="alert alert-success" v-if="stageStatus === 'Approved'">
            You have <strong>{{stageStatus}}</strong> the nomination.
          </div>
          <div role="alert" class="alert alert-danger" v-if="stageStatus === 'Rejected'">
            You have <strong>{{stageStatus}}</strong> the nomination.
          </div>
        </div>
        <!-- <div v-if="nomination.teamnominationworkflow[0].project_sponsor_comment === 'Declined'">
          <strong>Your reason for declining</strong><br>
          {{nomination.teamnominationworkflow[0].project_sponsor_comment}}
        </div>
        <div v-if="nomination.teamnominationworkflow[0].project_sponsor_comment === 'Accepted'">
          <div v-if="nomination.substantiation_comments[0] !== ''">
            <strong>Your comments</strong><br>
            {{nomination.teamnominationworkflow[0].project_sponsor_comment}}
          </div>
        </div> -->
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import Field150Word from '@/components/Field150Word'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Field150Word
  },
  computed: {
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      nominationDate: '',
      nomination: {},
      nominationCategory: '',
      showSubstationFields: true,
      acceptDeclineMsg: '',
      nominatedComments: '',
      termsCheckbox: false,
      termsNotAccepted: false,
      nominationAccepted: false,
      nominationDeclineReason: '',
      stageStatus: '',
      award: [],
      validationErrMsg: '',
      stageApprove: false,
      workflowStages: [],
      workflowStagesLabel: [],
      nextStage: '',
      nextStageLabel: '',
      hierarchicalMessage: [],
      displayHM: true,
      bigupsEcards: '',
      nominatorCompany: ''
    }
  },
  created () {
    console.log('profile details ', this)
    console.log('profile details username-> ', this.getProfileDetails)
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('nomination/' + this.$route.params.id + '?_embed')
      .then(response => {
        console.log('NominationReview', response.data)
        this.workflowStages = WordpressRestURI.workflowStages
        this.workflowStagesLabel = WordpressRestURI.workflowStagesLabel
        this.nomination = response.data
        if (this.nomination.nominator_details.length > 0 && this.nomination.nominator_details[0][0]['employee-company'] && this.nomination.nominator_details[0][0]['employee-company'] != ''){
            this.nominatorCompany = this.nomination.nominator_details[0][0]['employee-company']
            console.log('created if this.nomination.nominator_details.length ', this.nomination.nominator_details.length, Array.isArray(response.data.nominator_details[0][0]), this.nominatorCompany)
        } else if (this.nomination.nominator_details.length > 0 && this.nomination.nominator_details[0][0][0]['employee-company'] && this.nomination.nominator_details[0][0][0]['employee-company'] != '') {
            this.nominatorCompany = this.nomination.nominator_details[0][0][0]['employee-company']
            console.log('created else this.nomination.nominator_details.length ', this.nomination.nominator_details.length, Array.isArray(response.data.nominator_details[0][0]), this.nominatorCompany)
        } else {
        
        }
        console.log('created this.nominatorCompany ', this.nominatorCompany, this.nomination.nominator_details[0][0])
        if (this.nomination.nomination_event_category && this.nomination.nomination_event_category.includes(139)) {
            this.nomination.content.rendered = this.nomination.content.rendered.replace('<strong>Why are you nominating this person?</strong>', '<strong>Why are you nominating this team?</strong>')
        }
        this.getDate()
        if (this.nomination.isteamaward.includes('true')) {
          do {
            if (this.nomination.nominationteam[0].length === 1) {
              this.nomination.nominationteam[0] = this.nomination.nominationteam[0][0]
            }
          } while (this.nomination.nominationteam[0].length === 1)
        }
        if (this.nomination.bigups_ecards.length > 1) {
          this.bigupsEcards = this.nomination.bigups_ecards[1]
        }
        console.log(' this.bigupsEcards ', this.bigupsEcards)

        this.nominationCategory = response.data._embedded['wp:term'][1].map(x => x.name).filter(x => x !== 'VE Awards').join()
        this.contentReady = true
        this.nominationAccepted = response.data.nomination_approve_decline[0] === 'Accepted'
        var currentStage = this.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === this.$route.params.level.toLowerCase())
        if (currentStage[0].hasOwnProperty('project_sponsor_status')) {
          if (currentStage[0]['project_sponsor_status'] === 'Approve') {
            this.stageApprove = (currentStage[0]['project_sponsor_status'] === 'Approve')
            this.stageStatus = 'Approved'
          } else if (currentStage[0]['project_sponsor_status'] === 'Reject') {
            this.stageApprove = (currentStage[0]['project_sponsor_status'] === 'Reject')
            this.stageStatus = 'Rejected'
          }

          if (this.$route.params.level !== '') {
            var self = this
            // this.displayHM = (this.$route.query.status === 'review')
            // this.hierarchicalMessage = this.nomination.teamnominationworkflow[0].filter(r => r.project_sponsor_comment.indexOf('Rejected by') === -1 || r.project_sponsor_comment.trim() !== '')
            this.hierarchicalMessage = this.workflowStages.map( function(r) {
              return self.nomination.teamnominationworkflow[0].filter(t => t.project_sponsor_name.toLowerCase() === r)[0]
            })
            // Remove duplicate for 
            this.hierarchicalMessage = this.hierarchicalMessage.filter(function(t){ return t !== undefined })
          }
        }
        if (this.nomination.isteamaward.includes('true')) {
          var categorySlug = response.data.slug.split('-by')[0] // TODO: FIND A VALID SLUG
          // BELOW CALL is required to pull data for Mail Body
          WordpressRestAPI.getViewContent('nomination_event?slug=' + categorySlug + '&_embed')
            .then(response => {
              this.award = response.data[0]
              console.log('Awards in NR', this.award)
            })
            .catch(e => {
              console.error(e)
            })
        }
        console.log(this.nominationAccepted + ' <- status')
      })
      .catch(e => {
        this.childContentLoadError = 'Oops! We had a problem with loading your nomination. Please try again later.'
        console.error(e)
      })
  },
  methods: {
    getDate: function() {
      let d = this.nomination.date.split('T')
      let options = {year: "numeric", month: "short", day: "numeric"};
      this.nominationDate = new Intl.DateTimeFormat('en-US', options).format(new Date(d[0]))
    },
    nthDate: function(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    },  
    populateFieldInput: function (content) {
      if (content.label === 'Add comments:') {
        this.nominatedComments = content.content
      }
    },
    promoteNomiationtoNextStage: function (status) {
      let emailBody = ''
      var tempEmail = []
      if (status === 'Reject') {
        // TODO: Change the Email template once received
        emailBody = NominationNotification.nominationBodyHRBPForRejection({
          reviewLink: WordpressRestURI.frontEndDomain + '/#/login/my-profile',
          position: this.nextStageLabel
        })
        tempEmail = this.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === this.workflowStages[2])
      } else if (status === 'Approve') {
        emailBody = NominationNotification.nominationBodyProjectSponsorWithReview({
          //reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-manager+' + this.$route.params.id + '+' + this.nextStage,
          reviewLink: WordpressRestURI.frontEndDomain + '#/login/my-profile',
          position: this.nextStageLabel
        })
        tempEmail = this.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === this.nextStage)
      }
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: tempEmail[0].project_sponsor_email,
          subject: 'You have been identified as ' + this.nextStageLabel + ' on ThinkTank',
          message: emailBody
        },
        json: true
      }
      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log('promoteNomiationtoNextStage268 email response emailNominationNotification ', emailNominationNotification , response.data)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    acceptDecline: function (status) {
      var self = this
      self.validationErrMsg = ''
      if (self.termsCheckbox || status === 'Reject') {
        self.termsNotAccepted = !self.termsCheckbox
        if (status === 'Approve' && self.termsCheckbox) {
          self.validationErrMsg = ''
          self.updateNomination(status)
        } else if (self.nominatedComments.trim() == "") {
          self.validationErrMsg = 'Please provide Rejection Reason/Comment!'
        } else if (self.termsCheckbox) {
          self.validationErrMsg = ''
          self.updateNomination(status)
        }
      } else {
        self.termsNotAccepted = true
      }
    },
    sentNominatorNotification: function (status = 'Approve') {
      console.log(' sentNominatorNotification ')
      WordpressRestAPI.getViewContent('users/' + this.nomination.author + '?&_embed')
        .then(response => {
          var nominationEmail = response.data.user_email
          var nominationName = response.data.name
          // GET CATEGORY NAME
          if (this.nomination.isteamaward.length > 0 && this.nomination.nominationteam[0] !== null) {
            if (this.nomination._embedded['wp:term'][0].filter(d => d.id === 139).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][0].filter(d => d.id === 139)[0].name
            } else if (this.nomination._embedded['wp:term'][1].filter(d => d.id === 139).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][1].filter(d => d.id === 139)[0].name
            }
          } else {
            if (this.nomination._embedded['wp:term'][0].filter(d => d.id === 100).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][0].filter(d => d.id === 100)[0].name
            } else if (this.nomination._embedded['wp:term'][1].filter(d => d.id === 100).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][1].filter(d => d.id === 100)[0].name
            }
          }

          var d = new Date(this.nomination.date)
          var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

              // to: 'deenanath.mishra@nihilent.com',
          var emailNominationNotification = {
            method: 'POST',
            data: {
              to: nominationEmail,
              subject: 'CONGRATULATIONS: #WeSeeYou Recognition Award Confirmation',
              message: ''
            },
            json: true
          }
          if (status === 'Reject') {
            emailNominationNotification.data.message = NominationNotification.nominatorRejectionConfirmationForEmployeeAward({
              nominee: nominationName,
              awardName: awardName,
              submissionDate: d.getDate() + this.nthDate(d.getDate()) + " of " + months[d.getMonth()] + ' ' + d.getFullYear()
            })
            emailNominationNotification.data.subject = 'NOTIFICATION: #WeSeeYou Recognition Award Confirmation'
          } else {
            emailNominationNotification.data.message = NominationNotification.nominatorConfirmationForEmployeeAward({
              nominee: nominationName,
              awardName: awardName,
              //reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination-employee-award+' + this.$route.params.id,
              reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile',
              submissionDate: d.getDate() + this.nthDate(d.getDate()) + " of " + months[d.getMonth()] + ' ' + d.getFullYear()
            })
          }

          WordpressRestAPI.sendEmail(emailNominationNotification)
            .then(function (response) {
              console.log(' emailNominationNotification', emailNominationNotification,  response.data)
            })
            .catch(function (e) {
              console.error(e)
            })
      })
      .catch(e => {
        console.error(e)
        return '';
      })
    },
    sentNomineeNotification: function () {
      WordpressRestAPI.getViewContent('employeehierarchy?slug=' + this.nomination.nominee_slug[0] + '&_embed')
        .then(response => {
          var nomineeEmail = response.data[0].title.rendered
          var nomineeName = this.nomination.nominee_name[0]
          // GET CATEGORY NAME
          if (this.nomination._embedded['wp:term'][0].filter(d => d.id === 100).length > 0 ) {
            var awardName = this.nomination._embedded['wp:term'][0].filter(d => d.id === 100)[0].name
          } else if (this.nomination._embedded['wp:term'][1].filter(d => d.id === 100).length > 0 ) {
            var awardName = this.nomination._embedded['wp:term'][1].filter(d => d.id === 100)[0].name
          }
          let ccMail = ''
          let ccMailChunks = this.nomination.teamnominationworkflow[0].map(function (name, index) {
            if (name.project_sponsor_name.toLowerCase() !== "exco2") {
                return name.project_sponsor_email
            }
          })
          ccMail = ccMailChunks.join(',')
          console.log('this.NominationTeamNames ccMail ', ccMail)
          let emailBody = NominationNotification.nomineeConfirmationEmployeeAward({
            nominee: nomineeName,
            awardName: awardName,
            company: 'Multichoice Support Services',
            reason: this.nomination.content.rendered,
            reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile',            
          })
          console.log('sentNomineeNotification this.nomination.bigups_ecards.length ', this.nomination.bigups_ecards.length)
          console.log('sentNomineeNotification nomineeEmail ', nomineeEmail,  ' message ', emailBody,' attachmentId ', this.nomination.id, ' recipient ', this.nomination.nominee_name[0])
          if (this.nomination.bigups_ecards.length === 2) {
            var emailNominationNotification = {
              method: 'POST',
              data: {
                to: nomineeEmail,
                subject: 'Congratulations on your Employee of the Month Award',
                message: emailBody,
                cc: ccMail,
                recipient: this.nomination.nominee_name[0]
              },
              json: true
            }
          } else {
            var emailNominationNotification = {
              method: 'POST',
              data: {
                to: nomineeEmail,
                subject: 'Congratulations on your Employee of the Month Award',
                message: emailBody,
                cc: ccMail,
                recipient: this.nomination.nominee_name[0]
              },
              json: true
            }
          }
          var self = this
          WordpressRestAPI.sendEmail(emailNominationNotification)
            .then(function (response) {
              console.log(' emailNominationNotification 387', emailNominationNotification, response.data)
              self.$router.push('/')
            })
            .catch(function (e) {
              console.error(e)
            })
      })
      .catch(e => {
        console.error(e)
        return '';
      })        
    },
    sentTeamNomineeNotification: function(memberId = 0) {
      var self= this
      if (self.nomination._embedded['wp:term'][0].filter(d => d.id === 139).length > 0 ) {
        var awardName = self.nomination._embedded['wp:term'][0].filter(d => d.id === 139)[0].name
      } else if (self.nomination._embedded['wp:term'][1].filter(d => d.id === 139).length > 0 ) {
        var awardName = self.nomination._embedded['wp:term'][1].filter(d => d.id === 139)[0].name
      }
      console.log(' self.nomination ', self.nomination)
      if (memberId < self.nomination.nominationteam[0].length) {
      // for (var i=memberId; i <= this.nomination.nominationteam.length; i++) {
      let nomineeEmailList = this.nomination.nominationteam[0].map(function (name, index) {
          return name.member_email
      })
      let nomineeEmail = nomineeEmailList.join(',')
      let emailBody = NominationNotification.nomineeConfirmationEmployeeAward({
        nominee: self.nomination.nominationteam[0][memberId].member_name,
        awardName: awardName,
        reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile'
      })
      let ccMail = ''
      let ccMailChunks = this.nomination.teamnominationworkflow[0].map(function (name, index) {
        if (name.project_sponsor_name.toLowerCase() === "hrbp")  {
            return name.project_sponsor_email
        }
      })
      ccMail = ccMailChunks.join(',')
      console.log('this.NominationTeamNames ccMail ', ccMail)

      console.log('sentTeamNomineeNotification emailBody ', emailBody)
      console.log('sentTeamNomineeNotification  employeehierarchy?slug=' + self.nomination.nominationteam[0][memberId].member_slug + '&_embed')
      WordpressRestAPI.getViewContent('employeehierarchy?slug=' + self.nomination.nominationteam[0][memberId].member_slug + '&_embed')
        .then(response => {
          console.log('sentTeamNomineeNotification title ', response.data[0].title.rendered)
          console.log(' this.nomination.bigups_ecards.length ', this.nomination.bigups_ecards.length)
          var emailNominationNotification = {
            method: 'POST',
            data: {
              to: nomineeEmail,
              subject: 'Congratulations on your Team of the Month Award',
              message: emailBody,
              cc: ccMail,
              recipient: self.nomination.nominationteam[0][memberId].member_name
            },
            json: true
          }
          WordpressRestAPI.sendEmail(emailNominationNotification)
            .then(function (response) {
              console.log(response.data)
              memberId++
              //self.sentTeamNomineeNotification(memberId)
            })
            .catch(function (e) {
              console.error(e)
            })
        })
        .catch(function (e) {
          console.error(e)
        })
      } else {
        console.log('outside team nominations')
        self.$router.push('/')
      }
    },
    updateNominatorNominee: function () {
      if (this.nomination.nomination_event_category[0] === 139 || this.nomination.nomination_event_category[1] === 139) {
        //this.sentNominatorNotification()
        this.sentTeamNomineeNotification()
      }
      else if (this.nomination.nomination_event_category[0] === 100 || this.nomination.nomination_event_category[1] === 100) {
        // 100 - Employee of the month
        //this.sentNominatorNotification()
        this.sentNomineeNotification()
      }
    },
    sentRejectNotificationtoWorkflow: function(nomination, stage = false) {
      var self = this
      let rejectedStage = self.workflowStages.indexOf(self.$route.params.level.toLowerCase())
      if (stage === false) stage = rejectedStage - 1
      let nomineeName = '';
      if (nomination.nominationteam[0] !== null) {
        //Team Nomination
        nomineeName = nomination.nominationteam[0][0].member_name + ' and Team'
      } else {
        nomineeName = nomination.nominee_name[0]
      }
      let toLowerCaseStage = '';
      if (!self.workflowStages[stage]) {
        toLowerCaseStage = '';
      } else {
        toLowerCaseStage = self.workflowStages[stage].toLowerCase()
      }

      if (self.nomination.isteamaward.length > 0 && self.nomination.nominationteam[0] !== null) {
        if (self.nomination._embedded['wp:term'][0].filter(d => d.id === 139).length > 0 ) {
          var awardName = self.nomination._embedded['wp:term'][0].filter(d => d.id === 139)[0].name
        } else if (self.nomination._embedded['wp:term'][1].filter(d => d.id === 139).length > 0 ) {
          var awardName = self.nomination._embedded['wp:term'][1].filter(d => d.id === 139)[0].name
        }
        awardName = 'Teams'
      } else {
        if (self.nomination._embedded['wp:term'][0].filter(d => d.id === 100).length > 0 ) {
          var awardName = self.nomination._embedded['wp:term'][0].filter(d => d.id === 100)[0].name
        } else if (self.nomination._embedded['wp:term'][1].filter(d => d.id === 100).length > 0 ) {
          var awardName = self.nomination._embedded['wp:term'][1].filter(d => d.id === 100)[0].name
        }
      }
      var d = new Date(self.nomination.date)
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

      let tempEmail = nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === toLowerCaseStage)
      console.log(' tempEmail ', tempEmail)
      let emailBody = NominationNotification.workflowNotificationForRejectionForEmployeeAward({
        nominee: nomineeName,
        awardName:awardName,
        level: self.workflowStagesLabel[rejectedStage],
        submissionDate: d.getDate() + this.nthDate(d.getDate()) + " of " + months[d.getMonth()] + ' ' + d.getFullYear()
      })
          // to: 'deenanath.mishra@nihilent.com',
      console.log(' emailBody', emailBody)
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: tempEmail[0].project_sponsor_email,
          subject: 'NOTIFICATION: #WeSeeYou Recognition Award Confirmation',
          message: emailBody
        },
        json: true
      }
      console.log(' emailNominationNotification', emailNominationNotification)
      // console.log('Mail',emailNominationNotification)
      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log('  ', ' stage ', stage , ' response.data ', response.data)
          //if (stage !== 1)
            //self.sentRejectNotificationtoWorkflow(nomination, stage - 1)
          self.$router.push('/')
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    updateRejectionNotification: function(nomination) {
      //this.sentNominatorNotification('Reject')
      this.sentRejectNotificationtoWorkflow(nomination,3)
    },
    updateNomination: function (status) {
      var self = this
      console.log('DATA', self.nomination.teamnominationworkflow)
      var sendNominationPS = {
        method: 'POST',
        data: {},
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      sendNominationPS.data.teamnominationworkflow = []
      var d = new Date()
      for (var i = 0; i < self.nomination.teamnominationworkflow[0].length; i++) {
        // UPDATE CURRENT STATUS
        if (self.nomination.teamnominationworkflow[0][i].project_sponsor_name.toLowerCase() === self.$route.params.level.toLowerCase()) {
          sendNominationPS.data.teamnominationworkflow.push({
            'project_sponsor_email': self.nomination.teamnominationworkflow[0][i].project_sponsor_email,
            'project_sponsor_status': status,
            'project_sponsor_comment': self.nominatedComments,
            'project_sponsor_name': self.nomination.teamnominationworkflow[0][i].project_sponsor_name,
            'project_sponsor_datetime': d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
          })
        } else {
          // RESTORE UNCHANGE VALUES
          if (status === 'Reject' && self.workflowStages.indexOf(self.nomination.teamnominationworkflow[0][i].project_sponsor_name.toLowerCase()) > self.workflowStages.indexOf(self.$route.params.level.toLowerCase())) {
            sendNominationPS.data.teamnominationworkflow.push({
              'project_sponsor_email': self.nomination.teamnominationworkflow[0][i].project_sponsor_email,
              'project_sponsor_comment': 'Rejected by ' + self.workflowStagesLabel[self.workflowStages.indexOf(self.$route.params.level.toLowerCase())],
              'project_sponsor_status': status,
              'project_sponsor_name': self.nomination.teamnominationworkflow[0][i].project_sponsor_name,
              'project_sponsor_datetime': self.nomination.teamnominationworkflow[0][i].project_sponsor_datetime
            })
          } else {
            sendNominationPS.data.teamnominationworkflow.push({
              'project_sponsor_email': self.nomination.teamnominationworkflow[0][i].project_sponsor_email,
              'project_sponsor_comment': self.nomination.teamnominationworkflow[0][i].project_sponsor_comment,
              'project_sponsor_status': self.nomination.teamnominationworkflow[0][i].project_sponsor_status,
              'project_sponsor_name': self.nomination.teamnominationworkflow[0][i].project_sponsor_name,
              'project_sponsor_datetime': self.nomination.teamnominationworkflow[0][i].project_sponsor_datetime
            })
          }
        }
      }
      //self.nextStage = 'exco2'
      console.log('src\components\routes\NominationEmployeeAwardReview.vue sendNominationPS ', sendNominationPS)
      WordpressRestAPI.endpointWithAuthetication(sendNominationPS, 'nomination/' + self.$route.params.id)
        .then(function (response) {
          console.log(' nomination ', self.$route.params.id, sendNominationPS)
          self.showSubstationFields = false
          self.stageStatus = (status === 'Approve' ? 'Approved' : (status === 'Reject' ? 'Rejected' : status))
          self.acceptDeclineMsg = 'You have ' + status + ' the nomination'
          self.stageApprove = true
          if (status === 'Approve') {
            self.updateNominatorNominee()
          } else if (status === 'Reject') {
            console.log(' sendNominationPS  reject')
            self.nextStage = self.workflowStages[2]
            self.nextStageLabel = self.workflowStagesLabel[2]
            console.log('sendNominationPS before calling updateRejectionNotification self.nextStage', self.nextStage)
            //self.promoteNomiationtoNextStage(status)
            console.log('sendNominationPS before calling updateRejectionNotification self.nextStage', self.nextStage, ' response.data ',response.data)
            self.updateRejectionNotification(response.data)
            console.log('sendNominationPS after calling  updateRejectionNotification self.nextStageLabel', self.nextStageLabel)
            }
        })
        .catch(function (e) {
          console.error(e)
        })
    }
  },
  watch: {
    immediate: true,
    deep: true,
    getProfileDetails (newDetails, oldDetails) {
      var self = this
      var levelStatus = self.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === self.$route.params.level.toLowerCase())
      if (self.getProfileDetails.email.trim() !== levelStatus[0].project_sponsor_email.trim()) {
        console.log('Invalid user REDirect!')
        this.$router.push('/')
      } else if (self.nomination.nomination_approve_decline[0] !== 'Accepted') {
        this.$router.push('/')
      } else if (levelStatus.length === 0) {
      // variable length will be 0 where approval statges are not set
        this.$router.push('/')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/NominationManagerEmployeeAward.vue